import { Form, FormInstance, List } from "antd";
import BaseModal from "views/uikit/VLModal/BaseModal";
import VLButton from "views/uikit/Buttons/VLButton";
import styles from "./style.module.scss";
import CloudFileUpload from "./CloudFileUpload";

interface EvaluateLabelPropagationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRunEvaluation: () => void;
  form: FormInstance;
}

const EvaluateLabelPropagationModal = ({
  isOpen,
  onClose,
  onRunEvaluation,
  form,
}: EvaluateLabelPropagationModalProps) => {
  const handleRunEvaluation = () => {
    onRunEvaluation();
    onClose();
  };

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      variant="general"
      className={styles.modal}
      size="medium"
    >
      {isOpen && (
        <div className={styles.modalBase}>
          <div className={styles.header}>
            <span className={styles.title}>Evaluate Label Propagation</span>
          </div>

          <Form
            id={`evaluate-label-propagation-form`}
            form={form}
            layout="vertical"
            className={styles.applyDashBorder}
            onFinish={handleRunEvaluation}
          >
            <CloudFileUpload form={form} />

            <div className={styles.noteContainer}>
              <div className={styles.noteContent}>
                <div className={styles.noteHeader}>Note:</div>
                <List
                  className={styles.noteList}
                  size="small"
                  dataSource={[
                    `File names must be exactly: DB.csv, Classes.json`,
                    `
                        Image path in DB.csv must contain the folder name
                        (before /images)`,
                  ]}
                  renderItem={(item) => (
                    <List.Item className={styles.noteListItem}>
                      {item}
                    </List.Item>
                  )}
                />
              </div>
            </div>

            <div className={styles.buttonContainer}>
              <VLButton
                type="primary"
                text="Run Evaluation"
                htmlType="submit"
                form={`evaluate-label-propagation-form`}
                className={styles.button}
              />
            </div>
          </Form>
        </div>
      )}
    </BaseModal>
  );
};

export default EvaluateLabelPropagationModal;
